import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AlertTypesEnum} from '../../interfaces/AlertTypesEnum';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({opacity: 0}),
        animate('200ms', style({opacity: 1})),
      ]),
      transition(':leave', [
        animate('200ms', style({opacity: 0})),
      ]),
    ]),
  ],
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnChanges {
  @Input() show = true;
  @Input() type: AlertTypesEnum = AlertTypesEnum.Info;
  @Input() message = '';
  @Input() description = '';
  @Input() hideCloseButton: boolean;
  @Input() hasCustomCloseButton: boolean;
  @Input() global: boolean;
  @Input() autohide: number = 4; // seconds
  @Input() buttonText = 'Don\'t show again';
  @Input() useButtonImage = true;
  @Input() largeButton: boolean;
  @Input() paddingBottom = 0;
  @Input() textFullWidth: boolean;
  @Input() maxWidth = '333px';
  @Input() closeButtonName;
  @Input() hasSecondCustomCloseButton: boolean;
  @Input() secondCustomCloseButtonText: string;
  @Input() hasContent: boolean;

  @Output() closeAlert: EventEmitter<void> = new EventEmitter();
  @Output() closeOnButton: EventEmitter<void> = new EventEmitter();
  @Output() secondCloseButtonClicked: EventEmitter<void> = new EventEmitter();

  AlertTypesEnum = AlertTypesEnum;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show && changes.show.currentValue && this.autohide) {
      setTimeout(() => this.closeAlert.emit(), this.autohide * 1000);
    }
  }
}
